// extracted by mini-css-extract-plugin
export default {"truncate":"styles_truncate__hkVxd"};